import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { WarningContentInfoIcon } from '../../assets/icons';
import { BigButton, Input, Loader, ModalButtonArea } from '../../common';
import Switch from '../../components/admin/switch';
import PaymentDoneIcon from '../../components/icons/PaymentDone';
import { COMPONENT_LOAD_NAMES, ORG_JOIN_REQUEST_STATUS } from '../../constants/constants';
import { useUserContext, getCurrentUser } from '../../contexts/UserContext';
import {
  apiGetOrgRequestList,
  apiGetOrgRequestStatus,
  apiGetPermissionsList,
  apiGetUserDetails,
  apiPostAcceptOrDeniedJoinOrgRequest,
  apiPostJoinOrgRequest,
  apiUpdateOrganization,
} from '../../helpers/api';
import { handleErrorMessageFromAPIFailer } from '../../helpers/axiosHelper';
import { getRandomColor } from '../../helpers/jsHelper';
import { errorToast, successToastV2 } from '../../helpers/toastHelper';
import { selectChooseYourOrgPopOpen, setChooseYourOrgPopOpen } from '../../redux/slicers/uiSlicer';
import styles from './NewRegister.module.scss';
import { userPilotEvents } from '../../common/Userpilot/userpilotHelper';

export const ChooseYourOrg = (props) => {
  const { trackSignupExistingOrgPopup, trackSignupSignupNewOrg, trackClickedJoinExistingRrg } = userPilotEvents();
  const orgList = props?.orgList || [];
  const enableJoinBtn = props?.orgList?.some(({ selected }) => selected);

  useEffect(() => {
    trackSignupExistingOrgPopup(null,{})
  }, []);

  const handleCreate = () => {
    trackSignupSignupNewOrg(null,{
      join_existing_organisation:"No",
      create_new_org:"Yes"
    })
    props?.handleCreate()
  }

  const handleJoinOrg = () => {
    const selectedOrg = orgList?.filter(({ selected }) => selected);
    trackClickedJoinExistingRrg(null,{
      join_existing_organisation:"Yes",
      create_new_org:"No",
      select_org:selectedOrg?.map(org => org?.name).join(","),
      request_from:"Signup"
    })
    window.$selectedOrg = selectedOrg?.map(org => org?.name).join(",")
    props?.handleJoinOrg()
  }
  
  return (
    <div className={styles.chooseYourOrg}>
      <h2>Choose Your Organization</h2>

      <div className={styles.subDescription}>
        <p>It looks like you’re signing up with an email from an existing organization.</p>
        <p>Would you like to join one of the organizations below or create a new one?</p>
      </div>
      {!props?.hideInput && (
        <div className={styles.inputContainer}>
          <Input
            placeholder="Search By Organization Name"
            value={props?.search || null}
            onChange={(v) => props?.setSearch?.(v.value)}
          />
        </div>
      )}
      <div className={styles.orgListContainer}>
        {!orgList?.length && (
          <div>
            <span>No data available.</span>
          </div>
        )}
        <ul className={styles.orgList}>
          {orgList?.map((org, index) => {
            return (
              <>
                <li key={org?.id}>
                  <input
                    type="checkbox"
                    checked={org?.selected}
                    name="inverted1"
                    onChange={() => props?.handleSelectedOrg?.(org?.id)}
                  />
                  <span
                    className={styles.avatar}
                    style={{ backgroundColor: org?.bgColor || '#EFAB5D' }}>
                    {org?.name?.trim()?.charAt(0) || 'O'}
                  </span>
                  <span>{org?.name}</span>
                </li>
                {index + 1 === orgList?.length && props?.loadingMore && (
                  <li>{props?.loadingMore}</li>
                )}
              </>
            );
          })}
        </ul>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`lf-btn-3 keep-text ${styles.createNewBtn}`}
          onClick={()=> handleCreate()}
          buttonTitle="Create new"
        />
        <BigButton
          className={`lf-btn-1 keep-text white-text ${styles.joinBtn}`}
          onClick={()=> handleJoinOrg()}
          disabled={!enableJoinBtn}
          isLoading={props?.submitLoader}
          buttonTitle="Join"
        />
      </div>
    </div>
  );
};

export const RequestSentSuccess = (props) => {
  const { trackRequestSent } = userPilotEvents();

  useEffect(()=> {
     !props?.stopEvent && trackRequestSent(null,{
        join_existing_organisation:"Yes",
        create_new_org:"No",
        request_for:"Signup",
        select_org:window.$selectedOrg || ''
      })
  },[])
  
   const handleContinue = () =>{
    !props?.stopEvent && trackRequestSent(null,{
        join_existing_organisation:"Yes",
        create_new_org:"No",
        request_for:"Signup",
        select_org:window.$selectedOrg || ''
      })
    props?.updateOrgNameAPI()
  }

  return (
    <div className={styles.RequestSentOrg}>
      <h2>Request sent successfully!</h2>

      <div className={styles.subDescription}>
        <p>
          Your request to join the organization has been sent. You will be notified once the owner
          reviews and accepts your request.
        </p>
        {!props?.hideInput && (
          <p>
            Meanwhile, you can create your own organization to continue working on the platform.
          </p>
        )}
      </div>

      {!props?.hideInput && (
        <div className={styles.inputContainer}>
          <Input
            placeholder="Enter organization name"
            value={props?.orgName || null}
            onChange={(v) => props?.setOrgName?.(v.value)}
          />
        </div>
      )}

      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.continueBtn}`}
          onClick={handleContinue}
          isLoading={props?.submitLoader}
          disabled={!props?.hideInput ? (props?.orgName ? false : true) : false}
          buttonTitle="Continue"
        />
      </div>
    </div>
  );
};

export const JoinOrgRequest = (props) => {
  const { data } = props || {};
  const dispatch = useDispatch();
  const [showPermissionShow, setGivePermission] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    props?.setIsPermissionModal?.(showPermissionShow);
  }, [showPermissionShow]);

  useEffect(() => {
    if (data && data?.target_object_id) {
      getRequestStatusValue();
    }
  }, [data?.target_object_id]);

  const getRequestStatusValue = async () => {
    const params = `?request_id=${data?.target_object_id}`;
    const res = await apiGetOrgRequestStatus({ param: params });
    if(res?.data){
      setStatus(res.data?.status)
    }else{
      setStatus(null)
    }
  };

  const handleContinue = () => {
    if (status === ORG_JOIN_REQUEST_STATUS.APPROVED) {
      successToastV2('This request has already been approved.');
      props?.readNotification?.(data);
      dispatch(setChooseYourOrgPopOpen(false));
      return;
    }
    if (status === ORG_JOIN_REQUEST_STATUS.DENIED) {
      errorToast('This request has been declined by another admin or the owner.');
      props?.readNotification?.(data);
      dispatch(setChooseYourOrgPopOpen(false));
      return;
    }
    setGivePermission(true);
  };

  if (showPermissionShow) {
    return <GivePermission {...props} setGivePermission={setGivePermission} />;
  }

  const email = data?.data?.join_request_data?.email;

  return (
    <div className={styles.RequestSentOrg}>
      <h2>Join Organization Request</h2>

      <div className={styles.subDescription}>
        <p>
          {data?.name} {email ? `(${email})` : ''} is requesting to join your organization. Continue
          to adjust the permissions or deny the request.
        </p>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.continueBtn}`}
          onClick={() => handleContinue()}
          disabled={false}
          buttonTitle="Continue"
        />
      </div>
    </div>
  );
};

export const AcceptOrDeniedOrgRequest = (props) => {
  const { data, isSuccess, readNotification } = props || {};

  if (!data) {
    return null;
  }

  return (
    <div className={styles.RequestSentOrg}>
      <p>{isSuccess ? <PaymentDoneIcon /> : <WarningContentInfoIcon />}</p>
      <h2> {isSuccess ? 'Access Granted' : 'Access Denied'} </h2>
      <div className={styles.subDescription}>
        <p>
          {isSuccess
            ? `Your request to join ${data?.data?.join_request_data?.organization} has been approved! You can switch between
          organizations from Organization tab.`
            : `Your request to join ${data?.data?.join_request_data?.organization} has been denied! You can continue using your current
          organization and contact admin for joining ${data?.data?.join_request_data?.organization}.`}
        </p>
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.continueBtn}`}
          onClick={() => readNotification?.(data)}
          disabled={false}
          buttonTitle="Continue"
        />
      </div>
    </div>
  );
};

export const NewOrg = (props) => {
  const { trackSignupCreateNewOrgSuccess } = userPilotEvents();
  const handleCreateOrg = () => {
    trackSignupCreateNewOrgSuccess(null,{join_existing_organisation:"No",create_new_org_edit_org:props?.orgName})
    props?.updateOrgNameAPI()
  }

  return (
    <div className={styles.RequestSentOrg}>
      <h2>New Organization</h2>

      <div className={styles.subDescription}>
        <p>Please enter a name for your new organization.</p>
      </div>
      <div className={styles.inputContainer}>
        <Input
          placeholder="Enter organization name"
          value={props?.orgName || null}
          onChange={(v) => props?.setOrgName?.(v.value)}
        />
      </div>

      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.continueBtn}`}
          onClick={handleCreateOrg}
          isLoading={props?.submitLoader}
          disabled={props?.orgName ? false : true}
          buttonTitle="Continue"
        />
      </div>
    </div>
  );
};

export const GivePermission = (props) => {
  const currentUser = getCurrentUser();
  const { trackAcceptRequest, trackDeniedRequest } = userPilotEvents();
  const [loading, setLoading] = useState(false);
  const [isSubmitLoading, setSubmitLoading] = useState(false);
  const [permissionsList, setPermissionsList] = useState([]);
  const [defaultPermissions, setDefaultPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [makeAdmin, setMakeAdmin] = useState(false);
  const { permissionsMap } = useUserContext();

  const handleChangeMakeAdmin = (e) => {
    let { checked } = e.target;

    if (checked) {
      let permissionIds = permissionsList.map((item) => item.id);
      setSelectedPermissions(permissionIds);
    } else {
      setSelectedPermissions(defaultPermissions);
    }

    setMakeAdmin(checked);
  };

  const handleSelectPermissions = (checked, id) => {
    if (checked) {
      setSelectedPermissions([...selectedPermissions, id]);
    } else {
      setSelectedPermissions(selectedPermissions?.filter((item) => item !== id));
    }
  };

  const handleAcceptRequest = async () => {
    setSubmitLoading('accept');
    const formData = new FormData();
    formData.append('is_approved', true);
    formData.append('request_id', props?.data?.target_object_id || props?.data?.id);
    selectedPermissions.forEach((permission) => formData.append('permission', permission));

    const permissionName = [] 
    permissionsList.map((list)=> {
      if(selectedPermissions.includes(list?.id)){
        permissionName.push(list?.name)
      }
    })
    try {
      const res = await apiPostAcceptOrDeniedJoinOrgRequest(formData);
      if (res.status) {
        trackAcceptRequest(null,{permission:permissionName.map(list => list).join(","),requester_user_id:props?.data?.recipient,org_name:currentUser?.organization_detail?.name,request_for:"Join Org"})
        props?.readNotification?.(props?.data);
        props?.setGivePermission?.(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDeniedRequest = async () => {
    setSubmitLoading('denied');
    const formData = new FormData();
    formData.append('is_approved', false);
    formData.append('request_id', props?.data?.target_object_id || props?.data?.id);
    try {
      const res = await apiPostAcceptOrDeniedJoinOrgRequest(formData);
      if (res.status) {
        trackDeniedRequest(null,{permission:null,requester_user_id:props?.data?.recipient,org_name:currentUser?.organization_detail?.name,request_for:"Join Org"})
        props?.readNotification?.(props?.data);
        props?.setGivePermission?.(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }
  };

  function getPermissionList() {
    apiGetPermissionsList('pre_fix=lf_invite_internal&per_page=100').then((res) =>
      setPermissionsList(res.results.filter((a) => a?.owner_can_manage === true && permissionsMap?.[a?.codename]))
    );
  }

  function getDefaultPermissions() {
    setLoading(true);
    apiGetPermissionsList('pre_fix=lf_invite_internal&default_permission=true')
      .then((res) => {
        let permissionIds = res.results
          .filter((a) => a?.owner_can_manage === true)
          .map((item) => item.id);

        setDefaultPermissions(permissionIds);
        setSelectedPermissions(permissionIds);
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    getPermissionList();
    getDefaultPermissions();
  }, []);

  return (
    <div className={styles.givePermission}>
      <div className="container mt-4 pb-4">
        <h2 className="fw-bold fs-4">Permissions</h2>
        <p style={{ color: '#5a5c61' }}>Select which permissions you want to assign to this user</p>

        {!loading ? (
          <Form.Group>
            <div className="permission-list">
              <div className="permission-item">
                <span className="text-capitalize">
                  Make Admin (It gives all rights &amp; permission)
                </span>
                <span>
                  <Switch checked={makeAdmin} onToggle={handleChangeMakeAdmin} />
                </span>
              </div>
              {permissionsList?.map((item) => {
                return (
                  <div key={item.id} className="permission-item">
                    <span className="text-capitalize">{item?.name}</span>
                    <span>
                      <Switch
                        checked={selectedPermissions.includes(item?.id)}
                        onToggle={(e) => handleSelectPermissions(e.target.checked, item?.id)}
                        toggleId={'toggleId'}
                      />
                    </span>
                  </div>
                );
              })}
            </div>
          </Form.Group>
        ) : (
          <Loader
            loading={loading}
            position="relative"
            backdrop={false}
            className="scroll-loader"
          />
        )}
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`lf-btn-3 keep-text ${styles.deniedRequest}`}
          onClick={handleDeniedRequest}
          buttonTitle="Denied Request"
          isLoading={isSubmitLoading === 'denied'}
        />
        <BigButton
          className={`lf-btn-1 keep-text white-text ${styles.acceptRequest}`}
          onClick={handleAcceptRequest}
          disabled={false}
          buttonTitle="Accept Request"
          isLoading={isSubmitLoading === 'accept'}
        />
      </div>
    </div>
  );
};

export const ManageOrgsChooseModel = (props) => {
  const dispatch = useDispatch();
  const { currentUser, updateUserData } = useUserContext();
  const show = useSelector(selectChooseYourOrgPopOpen);
  const [open, setOpen] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [orgName, setOrgName] = useState(currentUser?.organization_detail?.name);
  const [nextLink, setNextLink] = useState(null);
  const [search, setSearch] = useState('');
  const loaderRef = useRef(null); // Ref for the loading div

  useEffect(() => {
    if (currentUser?.organization_detail) {
      setOrgName(currentUser?.organization_detail?.name);
    }
  }, [currentUser]);

  const [componentLoad, setComponentLoad] = useState([
    {
      name: COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG,
      active: false,
      component: ChooseYourOrg,
    },
    {
      name: COMPONENT_LOAD_NAMES.REQUEST_SENT,
      active: false,
      component: RequestSentSuccess,
      className: styles.applyBgColor,
    },
    {
      name: COMPONENT_LOAD_NAMES.CREATE_NEW_ORG,
      active: false,
      component: NewOrg,
      className: styles.applyBgColor,
    },
  ]);

  useEffect(() => {
    if (show && !props?.body) {
      handleGetORGList();
    }
  }, [show]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const componentData = componentLoad?.find(({ active }) => active);
      if (componentData && componentData?.name === COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG) {
        handleGetORGList(!search, search);
      }
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [search]);

  useEffect(() => {
    // IntersectionObserver to load more data when the loaderRef is visible
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && nextLink) {
          handleGetORGList();
        }
      },
      { threshold: 1.0 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [nextLink]);

  const handleGetORGList = async (isReset, searchVal) => {
    const url =
      nextLink && !searchVal
        ? nextLink?.split('?')[1]
        : `per_page=50&page=1&sort=name&search=${search}`;
    const res = await apiGetOrgRequestList({ param: `?${url}` });
    if (res?.results?.length || searchVal) {
      setOpen(true);
      updateComponentLoad(COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG, true);
      if (searchVal || isReset) {
        setOrgList([...addBgColor(res?.results || [])]);
      } else {
        setOrgList((prevList) => [...prevList, ...addBgColor(res?.results || [])]); // Merge new results with current list
      }
      setNextLink(res.next_link);
    } else {
      setOpen(false);
      setOrgList([]);
      dispatch(setChooseYourOrgPopOpen(false));
      setNextLink(null);
    }
  };

  const resetStateValue = () => {
    search && setSearch(null);
    nextLink && setNextLink(null);
  };

  const addBgColor = (results) => {
    const data = results?.map((item) => {
      return {
        ...item,
        bgColor: getRandomColor(),
      };
    });
    return data;
  };

  const updateComponentLoad = (name, active) => {
    setComponentLoad((prevState) =>
      prevState.map((item) =>
        item.name === name ? { ...item, active } : { ...item, active: false }
      )
    );
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(setChooseYourOrgPopOpen(false));
    props?.readNotification?.();
    resetStateValue();
  };

  const handleSelectedOrg = (selectedId) => {
    if (!selectedId) return;
    const cloneOrgList = orgList.slice();
    const findIndex = cloneOrgList.findIndex(({ id }) => +id === +selectedId);
    if (~findIndex) {
      cloneOrgList[findIndex]['selected'] = cloneOrgList[findIndex].selected ? false : true;
    }
    setOrgList(cloneOrgList);
  };

  const currentComponent = componentLoad?.find(({ active }) => active);
  if (!props.body && (!open || !currentComponent?.component)) {
    return null;
  }

  const handleCreate = () => {
    updateComponentLoad(COMPONENT_LOAD_NAMES.CREATE_NEW_ORG, true);
    resetStateValue();
  };

  const handleJoinOrg = async () => {
    const selectedOrg = orgList.filter(({ selected }) => selected);
    if (!selectedOrg?.length) return;
    setSubmitLoader(true);
    try {
      // Make API calls sequentially
      for (const item of selectedOrg) {
        const formData = new FormData();
        formData.append('organization', +item.id);
        const res = await apiPostJoinOrgRequest(formData);
        if (!res?.status) {
          handleErrorMessageFromAPIFailer(res);
          setSubmitLoader(false);
          return; // Stop if any request fails
        }
      }
      updateComponentLoad(COMPONENT_LOAD_NAMES.REQUEST_SENT, true);
      resetStateValue();
    } catch (error) {
      handleErrorMessageFromAPIFailer(error);
    } finally {
      setSubmitLoader(false);
    }
  };

  function getUserDetails() {
    apiGetUserDetails()
      .then((response) => {
        if (response) {
          updateUserData();
        }
      })
      .finally(() => {});
  }

  const updateOrgName = async () => {
    setSubmitLoader(true);
    let formData = new FormData();
    formData.append('name', orgName.trim());

    apiUpdateOrganization(formData)
      .then((response) => {
        handleClose();
        getUserDetails();
      })
      .catch((error) => {
        handleErrorMessageFromAPIFailer(error || "Something went wrong while updating organization name. Please try again later!")
      })
      .catch((error) => {
        handleErrorMessageFromAPIFailer(error || "Something went wrong while updating organization name. Please try again later!")
      
      })
      .finally(() => {
        window.$updateName = true;
        setSubmitLoader(false);
      });
  };

  const openModal = Boolean(open || props?.body);

  return (
    <div
      className={`${styles.registerFlowContainer} ${props?.dialogClassName} ${
        props?.applyBg ? styles.applyBgColor : ''
      } ${currentComponent?.className}`}>
      <ModalButtonArea
        size={props?.size || 'lg'}
        startOpen={openModal}
        showModal={openModal}
        setShowModal={handleClose}
        centered={true}
        className={`${styles.registerFlowContainer} ${props?.dialogClassName} ${
          props?.applyBg ? styles.applyBgColor : ''
        } ${currentComponent?.className}`}
        bigButton={false}
        bigIcon={true}
        variant="link"
        onClose={handleClose}
        closeIconV2
        backdropClassName="overlay-dark"
        headingLeft
        body={
          props?.body ? (
            props.body
          ) : (
            <currentComponent.component
              orgList={orgList}
              submitLoader={submitLoader}
              handleJoinOrg={handleJoinOrg}
              handleCreate={handleCreate}
              handleSelectedOrg={handleSelectedOrg}
              orgName={orgName}
              setOrgName={setOrgName}
              updateOrgNameAPI={updateOrgName}
              loadingMore={
                currentComponent.name === COMPONENT_LOAD_NAMES.CHOOSE_YOUR_ORG &&
                nextLink && <div ref={loaderRef}>Loading more...</div>
              }
              search={search}
              setSearch={setSearch}
            />
          )
        }
      />
    </div>
  );
};
